import React from 'react';
//import Chip from '@material-ui/core/Chip';
//import Card from '@material-ui/core/Card';
//import LinearProgress from '@material-ui/core/LinearProgress';
//import EYCard from 'eymp-uicomps/components/Card';

import { Chip } from 'eymp-uicomps';
//import GlobalProgressBar from '../ProgressBar';

import './Chip.scss';
//import ToggleWithLabels from '../ToggleWithLabels';
import intl from 'react-intl-universal';

function GlobalChip(props) {
  const { data } = props;
  return (
    <div className="chip-root">
      {data ? (
        <Chip
          className={data.isRequireAction ? 'status-color-red' : 'status-color'}
          label={data.isRequireAction ? intl.get('newDashboard.caseCard.actionRequired') : data.progressStatus}
          status={'error'}
          textColor="white"
        />
      ) : (
        <Chip label={intl.get('newDashboard.caseCard.actionRequired')} status={'error'} textColor="white" />
      )}
    </div>
  );
}

export default GlobalChip;
